export function serializeConfigSnapshot({
    systemPrompt,
    guardrails,
    knowledge,
    modelo,
    temperatura,
}) {
    const normalizedKnowledge = (Array.isArray(knowledge) ? knowledge : [])
        .map((k) => ({
            filename: (k.filename ?? "").trim(),
            content: k.content ?? "",
        }))
        .filter((k) => k.filename)
        .sort((a, b) => a.filename.localeCompare(b.filename));

    return JSON.stringify({
        system_prompt: systemPrompt ?? "",
        guardrails: guardrails ?? "",
        knowledge: normalizedKnowledge,
        modelo: modelo ?? "",
        temperatura: temperatura === "" || temperatura == null ? "" : String(temperatura),
    });
}

export function isConfigDirty(snapshot, current) {
    if (!snapshot) return false;
    return snapshot !== serializeConfigSnapshot(current);
}

/**
 * Prioridade: draft > drift > unknown > applied
 */
export function resolveConfigTrust({ dirty, health, activeVersion }) {
    if (dirty) {
        return {
            state: "draft",
            label: "Rascunho local",
            detail: "Há alterações na tela que ainda não foram salvas. O bot continua com a versão aplicada anterior.",
        };
    }

    if (!health || health.status === "unknown") {
        return {
            state: "unknown",
            label: "Desconhecido",
            detail: "Não foi possível confirmar se o runtime (Redis) está com a mesma versão do painel.",
        };
    }

    const mongoId = health.mongo?.active_version ?? activeVersion ?? null;
    const runtimeId = health.runtime?.version_id ?? null;
    const mismatch = health.drift?.version_mismatch === true || (mongoId && runtimeId && mongoId !== runtimeId);

    if (health.status === "drift" || mismatch) {
        return {
            state: "drift",
            label: "Desalinhado",
            detail:
                health.drift?.detail === "chunk_count < 1"
                    ? "A versão parece salva, mas o conhecimento (chunks) no bot está incompleto. Use Reaplicar."
                    : "O que está salvo no painel não é o que o bot está usando agora. Use Reaplicar ou confira o painel Funcionamento.",
        };
    }

    if (health.status === "aligned") {
        return {
            state: "applied",
            label: "Aplicado",
            detail: "O que você vê (versão salva) é o que o bot está usando agora.",
        };
    }

    return {
        state: "unknown",
        label: "Desconhecido",
        detail: "Status de funcionamento incompleto — tente Atualizar.",
    };
}

export function trustBadgeClass(state) {
    if (state === "applied") return "bg-green-700 text-green-100";
    if (state === "draft") return "bg-amber-700 text-amber-50";
    if (state === "drift") return "bg-red-700 text-red-100";
    return "bg-gray-600 text-gray-200";
}
